import Vue from 'vue'
import Router from 'vue-router'

let demotree = resolve => require(['../components/comn/tree/demotree'], resolve)
let choice = resolve => require(['../components/comn/choice'], resolve)
let table = resolve => require(['../components/comn/table/table'], resolve)
let login = resolve => require(['../components/login.vue'], resolve)
let index = resolve => require(['../components/index.vue'], resolve)
let homePage = resolve => require(['../components/homePage.vue'], resolve)
let homePageSup = resolve => require(['../components/homePageSup.vue'], resolve)
let forgotPassword = resolve => require(['../components/forgotPassword.vue'], resolve)
let externalmenu = resolve => require(['../components/comn/externalmenu.vue'], resolve)
// 咨询管理/消息管理(ConsultingManage)
let announcementManage = resolve => require(['../components/ConsultingManage/announcementManage.vue'], resolve)
// 组织管理(OrganizaManage)
let organizationalStructure = resolve => require(['../components/OrganizaManage/organizationalStructure.vue'], resolve)
let generalManager = resolve => require(['../components/OrganizaManage/generalManager.vue'], resolve)
// 政策(policy)
let policyPreview = resolve => require(['../components/policy/policyPreview/policyPreview.vue'], resolve)
let orderPolicy = resolve => require(['../components/policy/orderPolicy/orderPolicy.vue'], resolve)
// let addOrderPolicy = resolve => require(['../components/policy/orderPolicy/addOrderPolicy.vue'], resolve)
let addOrderPolicy = resolve => require(['../components/policy/orderPolicy/addOrderPolicyNew.vue'], resolve)
// 调价规则
let adjustPrice = resolve => require(['../components/policy/adjust/adjustPrice.vue'], resolve)
// 低价看板
let recommendLowPrice = resolve => require(['../components/policy/recommendLowPrice/index.vue'], resolve)

// 钱包(wallet)
let adminWallet = resolve => require(['../components/wallet/adminWallet.vue'], resolve)
let wallet = resolve => require(['../components/wallet/wallet.vue'], resolve)
let walletSupplier = resolve => require(['../components/wallet/walletSupplier.vue'], resolve)
let walletDetail = resolve => require(['../components/wallet/walletDetail.vue'], resolve)
let walletLog = resolve => require(['../components/wallet/walletLog.vue'], resolve)
let walletLogAgent = resolve => require(['../components/wallet/walletLogAgent.vue'], resolve)
let settlement = resolve => require(['../components/wallet/settlement/settlement.vue'], resolve)
let settlementDetail = resolve => require(['../components/wallet/settlement/settlementDetail.vue'], resolve)
let cashAccountDetail = resolve => require(['../components/wallet/settlementSupplier/cashAccountDetail.vue'], resolve)
// 审核结算
let orderAudit = resolve => require(['../components/wallet/audit/orderAudit.vue'], resolve)
let refundAudit = resolve => require(['../components/wallet/audit/refundAudit.vue'], resolve)
let changeAudit = resolve => require(['../components/wallet/audit/changeAudit.vue'], resolve)
// 设置(SystemManage)
let shortMsgList = resolve => require(['../components/SystemManage/shortMsgList.vue'], resolve)
let account = resolve => require(['../components/SystemManage/account.vue'], resolve)
let oftenPassenger = resolve => require(['../components/SystemManage/oftenPassenger.vue'], resolve)
let roleManage = resolve => require(['../components/SystemManage/roleManage.vue'], resolve)
let systemLog = resolve => require(['../components/SystemManage/systemLog.vue'], resolve)
let Configuration = resolve => require(['../components/SystemManage/Configuration.vue'], resolve)
let menuControl = resolve => require(['../components/SystemManage/menuControl.vue'], resolve)
let operateLog = resolve => require(['../components/SystemManage/operateLog.vue'], resolve)
let systemsetting = resolve => require(['../components/SystemManage/systemSetting.vue'], resolve)
// 机票查询预定
let flightSearch = resolve => require(['../components/flight/flightSearch.vue'], resolve)
let flightSearchList = resolve => require(['../components/flight/flightSearchList.vue'], resolve)
let flightBooking = resolve => require(['../components/flight/flightBooking.vue'], resolve)
// 订单管理(flightOrder)
let changeFlightSearch = resolve => require(['../components/flight/changeFlightSearch.vue'], resolve)
let flightChangeMatch = resolve => require(['../components/flightOrder/flightChangeMatch.vue'], resolve)
let orderErrorTicket = resolve => require(['../components/flightOrder/orderErrorTicket.vue'], resolve)
let yqOrderMatch = resolve => require(['../components/flightOrder/yqOrderMatch.vue'], resolve)
let airportInfoList = resolve => require(['../components/Operate/airportInfoList.vue'], resolve)
let refundAccountConfirm = resolve => require(['../components/flightOrder/refundAccountConfirm.vue'], resolve)
let refundSubmit = resolve => require(['../components/flightOrder/refundSubmit.vue'], resolve)
let orderList = resolve => require(['../components/flightOrder/orderList.vue'], resolve)
let refundList = resolve => require(['../components/flightOrder/refundList.vue'], resolve)
let changeList = resolve => require(['../components/flightOrder/changeList.vue'], resolve)
let orderErrorList = resolve => require(['../components/flightOrder/orderErrorList.vue'], resolve)
let orderAppealList = resolve => require(['../components/flightOrder/orderAppealList.vue'], resolve)
let orderAppealDetail = resolve => require(['../components/flightOrder/orderAppealDetail.vue'], resolve)
let orderAssistList = resolve => require(['../components/flightOrder/orderAssistList.vue'], resolve)
let orderDetail = resolve => require(['../components/flightOrder/orderDetail.vue'], resolve)
let orderPay = resolve => require(['../components/flightOrder/orderPay.vue'], resolve)
let refundDetail = resolve => require(['../components/flightOrder/refundDetail.vue'], resolve)
let changeDetail = resolve => require(['../components/flightOrder/changeDetail.vue'], resolve)
let orderErrorDetail = resolve => require(['../components/flightOrder/orderErrorDetail.vue'], resolve)
let xcdList = resolve => require(['../components/flightOrder/xcdList.vue'], resolve)
let orderScan = resolve => require(['../components/flightOrder/orderScan.vue'], resolve)
let refundTimeConfig = resolve => require(['../components/flightOrder/refundTimeConfig.vue'], resolve)
let refundProcessingTime = resolve => require(['../components/flightOrder/refundProcessingTime.vue'], resolve)
let refundRemindConfig = resolve => require(['../components/flightOrder/refundRemindConfig.vue'], resolve)
let addHandMadeRefundOrder = resolve => require(['../components/flightOrder/addHandMadeRefundOrder.vue'], resolve)
let addHandMadeChangeOrder = resolve => require(['../components/flightOrder/addHandMadeChangeOrder.vue'], resolve)
let addHandMadeOrder = resolve => require(['../components/flightOrder/addHandMadeOrder.vue'], resolve)
let ticketNoVerifyList = resolve => require(['../components/flightOrder/ticketNoVerifyList.vue'], resolve)
let openTicket = resolve => require(['../components/flightOrder/openTicket.vue'], resolve)
let flightChangeList = resolve => require(['../components/flightOrder/flightChangeList.vue'], resolve)
let flightChangeSubscribe = resolve => require(['../components/flightOrder/flightChangeSubscribe.vue'], resolve)
let queryFlight = resolve => require(['../components/flightOrder/queryFlight.vue'], resolve)
// 汇率(exchange rate)
let zsCurrencyList = resolve => require(['../components/flightOrder/zsCurrencyList.vue'], resolve)
// 资源(Resources)
let airlineCycle = resolve => require(['../components/Resources/airlineCycle.vue'], resolve)
let freightDomestic = resolve => require(['../components/Resources/freightDomestic.vue'], resolve)
let freightDomesticOld = resolve => require(['../components/Resources/freightDomesticOld.vue'], resolve)
let scheduling = resolve => require(['../components/Resources/scheduling.vue'], resolve)
let cacheManage = resolve => require(['../components/Resources/cacheManage.vue'], resolve)
let lowPriceSearch = resolve => require(['../components/Resources/lowPriceSearch.vue'], resolve)
let OutPurchasePolicy = resolve => require(['../components/Operate/OutPurchasePolicy.vue'], resolve)
// 渠道(Channel)
let ticketoutChannel = resolve => require(['../components/Channel/ticketoutChannel.vue'], resolve)
let ticketoutAccount = resolve => require(['../components/Channel/ticketoutAccount.vue'], resolve)
let payChannel = resolve => require(['../components/Channel/payChannel.vue'], resolve)
let divideConfig = resolve => require(['../components/Channel/divideConfig.vue'], resolve)
let refundAutoRule = resolve => require(['../components/Channel/refundAutoRule.vue'], resolve)
// 产品(Product)
let product = resolve => require(['../components/Product/product.vue'], resolve)
let productConfig = resolve => require(['../components/Product/productConfig.vue'], resolve)
let productDzFilter = resolve => require(['../components/Product/productDzFilter.vue'], resolve)
let ticketoutConfig = resolve => require(['../components/Product/ticketoutConfig.vue'], resolve)
let ticketOutAV = resolve => require(['../components/Product/ticketOutAV.vue'], resolve)
let productAircomConfig = resolve => require(['../components/Product/productAircomConfig.vue'], resolve)
let productAirlineConfig = resolve => require(['../components/Product/productAirlineConfig.vue'], resolve)
let zlpricequery = resolve => require(['../components/Product/zlPriceQuery.vue'], resolve)
let zlstatus = resolve => require(['../components/Product/zlStatus.vue'], resolve)
let productLogst = resolve => require(['../components/Product/productLogst.vue'], resolve)
let productPushLogst = resolve => require(['../components/Product/productPushLogst.vue'], resolve)
let fzxljy = resolve => require(['../components/Product/fzxljy.vue'], resolve)

let billList = resolve => require(['../components/Audit/billList.vue'], resolve)
let capitalTradeList = resolve => require(['../components/Audit/capitalTradeList.vue'], resolve)
let merchantCashList = resolve => require(['../components/Audit/merchantCashList.vue'], resolve)
// 财税(finance)
let orderStatistics = resolve => require(['../components/Finance/orderStatistics.vue'], resolve)
let orderReportPassengers = resolve => require(['../components/Finance/orderReportPassengers.vue'], resolve)
let refundOrderReport = resolve => require(['../components/Finance/refundOrderReport.vue'], resolve)
let changeOrderReport = resolve => require(['../components/Finance/changeOrderReport.vue'], resolve)
let errorOrderReport = resolve => require(['../components/Finance/errorOrderReport.vue'], resolve)
let orderFlightSummaryReport = resolve => require(['../components/Finance/orderFlightSummaryReport.vue'], resolve)
// 运营(Operate)
let refundChangeRule = resolve => require(['../components/Operate/refundChangeRule.vue'], resolve)
let logs = resolve => require(['../components/Operate/logs.vue'], resolve)
let bookinglogs = resolve => require(['../components/Operate/bookinglogs.vue'], resolve)
let accountStaff = resolve => require(['../components/Operate/accountStaff.vue'], resolve)
let accountPbStaff = resolve => require(['../components/Operate/accountPbStaff.vue'], resolve)
let menu = resolve => require(['../components/Operate/menu.vue'], resolve)
let shop = resolve => require(['../components/Operate/shop.vue'], resolve)
let practiceBaseManage = resolve => require(['../components/Operate/practiceBaseManage.vue'], resolve)
let paymentInfo = resolve => require(['../components/Operate/paymentInfo.vue'], resolve)
let dict = resolve => require(['../components/Operate/dict.vue'], resolve)
let policyCrawlsConfig = resolve => require(['../components/Operate/policyCrawlsConfig.vue'], resolve)
let freightScan = resolve => require(['../components/Operate/freightScan.vue'], resolve)
let freightPublic = resolve => require(['../components/Operate/freightPublic.vue'], resolve)
let etermScan = resolve => require(['../components/Operate/etermScan.vue'], resolve)
let etermCommand = resolve => require(['../components/Operate/etermCommand.vue'], resolve)
let policyScanCabin = resolve => require(['../components/Operate/policyScanCabin.vue'], resolve)
let agentfee = resolve => require(['../components/Operate/agentFee.vue'], resolve)
let bookingCrawls = resolve => require(['../components/Operate/bookingCrawls.vue'], resolve)
let contact = resolve => require(['../components/Operate/contact.vue'], resolve)
// h5
let h5 = resolve => require(['../components/h5/h5.vue'], resolve)
let loginH5 = resolve => require(['../components/h5/loginH5.vue'], resolve)
let listH5 = resolve => require(['../components/h5/listH5.vue'], resolve)
Vue.use(Router)
export default new Router({
  'linkActiveClass': 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      children: [
        // 组织管理
        {path: 'organizationalStructure', name: '部门管理', component: organizationalStructure},
        {path: 'generalManager', name: '岗位管理', component: generalManager},
        { path: 'practiceBaseManage', name: '商家管理', component: practiceBaseManage },
        { path: 'paymentInfo', name: '支付管理', component: paymentInfo },
        { path: 'paymentInfoM', name: '收款信息', component: paymentInfo },
        // 咨询管理/消息管理(ConsultingManage)
        {path: 'announcementManage', name: '公告管理', component: announcementManage},
        // 渠道(Channel)
        {path: 'divideConfig', name: '派单设置', component: divideConfig},
        {path: 'payChannel', name: '付款渠道管理', component: payChannel},
        {path: 'ticketoutAccount', name: '出票账号管理', component: ticketoutAccount},
        {path: 'ticketoutChannel', name: '出票渠道管理', component: ticketoutChannel},
        {path: 'refundAutoRule', name: '自动退票规则', component: refundAutoRule},
        // 政策(policy)
        { path: 'policyPreview', name: '数据预览', component: policyPreview },
        {path: 'orderPolicy', name: '政策管理', component: orderPolicy},
        {path: 'addOrderPolicy', name: '新增政策', component: addOrderPolicy},
        { path: 'auditOrderPolicy', name: '政策修改', component: addOrderPolicy },
        //  调价规则
        { path: 'adjustPrice', name: '调价规则', component: adjustPrice },
        //  低价看板
        { path: 'recommendLowPrice', name: '低价看板', component: recommendLowPrice },
        // 产品(Product)
        // 钱包(wallet)
        {path: 'adminWallet', name: '资金账户', component: adminWallet},
        { path: 'wallet', name: '资金账户', component: wallet },
        { path: 'walletSupplier', name: '资金账户', component: walletSupplier },
        {path: 'walletDetail', name: '资金变动', component: walletDetail},
        { path: 'walletLog', name: '充提审核', component: walletLog },
        { path: 'walletLogAgent', name: '提现记录', component: walletLogAgent },
        { path: 'settlement', name: '授信结算', component: settlement },
        { path: 'settlementDetail', name: '授信结算明细', component: settlementDetail },
        { path: 'cashAccountDetail', name: '现金账户明细', component: cashAccountDetail },
        // 审核结算
        { path: 'orderAudit', name: '出票费审核', component: orderAudit },
        { path: 'refundAudit', name: '退票费审核', component: refundAudit },
        { path: 'changeAudit', name: '改签费审核', component: changeAudit },
        // 汇率(exchange rate)
        {path: 'zsCurrencyList', name: '汇率表', component: zsCurrencyList},
        // 系统管理(SystemManage)
        {path: 'shortMsgList', name: '短信查询', component: shortMsgList},
        {path: 'account', name: '账号管理', component: account},
        {path: 'oftenPassenger', name: '常旅客页面', component: oftenPassenger},
        {path: 'accountStaff', name: '商家账号管理', component: accountStaff},
        {path: 'accountPbStaff', name: '商家账号管理', component: accountPbStaff},
        {path: 'shop', name: '店铺管理', component: shop},
        {path: 'roleManage', name: '角色管理', component: roleManage},
        { path: 'homePage', name: '首页', component: homePage },
        { path: 'homePageSup', name: '首页', component: homePageSup },
        {path: 'menu', name: '菜单管理', meta: {requireAuth: true}, component: menu},
        {path: 'systemLog', name: '系统日志', component: systemLog},
        {path: 'Configuration', name: '基础配置', component: Configuration},
        {path: 'menuControl', name: '权限控制', component: menuControl},
        {path: 'refundChangeRule', name: '航司退改签', component: refundChangeRule},
        {path: 'operateLog', name: '操作日志', component: operateLog},
        {path: 'systemsetting', name: '系统设置', component: systemsetting},
        {path: 'dict', name: '数据字典', component: dict},
        {path: 'policyCrawlsConfig', name: '政策爬虫', component: policyCrawlsConfig},
        {path: 'freightScan', name: '公布运价扫描', component: freightScan},
        {path: 'freightPublic', name: '公布运价', component: freightPublic},
        {path: 'etermScan', name: 'Eterm数据扫描', component: etermScan},
        {path: 'etermCommand', name: 'Eterm指令查询', component: etermCommand},
        {path: 'agentfee', name: '代理费管理', component: agentfee},
        {path: 'policyScanCabin', name: '扫舱政策', component: policyScanCabin},
        {path: 'zlpricequery', name: '报价接口查询', component: zlpricequery},
        {path: 'zlstatus', name: '直连接口状态', component: zlstatus},
        { path: 'bookingCrawls', name: '占座爬虫', component: bookingCrawls },
        { path: 'contact', name: '联系我们', component: contact },
        //  机票查询预定
        {path: 'flightSearch', name: '首页', component: flightSearch},
        {path: 'flightSearchList', name: '首页', component: flightSearchList},
        {path: 'flightBooking', name: '首页', component: flightBooking},
        {path: 'changeFlightSearch', name: '改签选择航班', component: changeFlightSearch},
        //  订单管理
        {path: 'orderList', name: '运营出票单查询', component: orderList},
        {path: 'orderDetail', name: '出票单详情', component: orderDetail},
        {path: 'cgorderList', name: '采购出票单查询', component: orderList},
        {path: 'gyorderList', name: '供应出票单查询', component: orderList},
        {path: 'orderPay', name: '订单支付页', component: orderPay},
        {path: 'dsdorderList', name: '待筛单', component: orderList},
        {path: 'ysdclorderList', name: '出票已锁待处理', component: orderList},
        {path: 'dclorderList', name: '出票全部待处理', component: orderList},
        {path: 'cpwcorderList', name: '出票完成', component: orderList},
        {path: 'ddqxorderList', name: '订单取消', component: orderList},
        {path: 'yqOrderMatch', name: '疫情订单匹配', component: yqOrderMatch},
        {path: 'airportInfoList', name: '机场信息', component: airportInfoList},
        {path: 'refundAccountConfirm', name: '退票费确认', component: refundAccountConfirm},
        {path: 'refundSubmit', name: '辅助退票', component: refundSubmit},
        {path: 'ticketNoVerifyList', name: '票号验证', component: ticketNoVerifyList},
        {path: 'openTicket', name: 'OPEN票', component: openTicket},
        {path: 'orderErrorTicket', name: '异常客票', component: orderErrorTicket},
        {path: 'flightChange', name: '航变', component: flightChangeList},
        {path: 'flightChangeSubscribe', name: '航变订阅', component: flightChangeSubscribe},
        {path: '/mflightChangeMatchu', name: '东航航变数据匹配', component: flightChangeMatch},
        {path: '/cflightChangeMatcha', name: '国航航变数据匹配', component: flightChangeMatch},
        {path: '/queryFlight', name: '航班动态', component: queryFlight},
        // 退票
        {path: 'ysdclRefundList', name: '退票已锁待处理', component: refundList},
        {path: 'ysychkdclRefundList', name: '退票已锁异常回款待处理', component: refundList},
        {path: 'dclrefundList', name: '退票全部待处理', component: refundList},
        {path: 'ychkdclRefundList', name: '退票全部异常回款待处理', component: refundList},
        {path: 'ystpycRefundList', name: '已锁退票异常', component: refundList},
        {path: 'ysjsycdclRefundList', name: '退票已锁结算异常待处理', component: refundList},
        {path: 'tpycrefundList', name: '全部退票异常', component: refundList},
        {path: 'jsycdclRefundList', name: '退票全部结算异常待处理', component: refundList},
        {path: 'ysjsycRefundList', name: '退票已锁结算异常', component: refundList},
        {path: 'jsycrefundList', name: '退票全部结算异常', component: refundList},
        {path: 'yshxycdclRefundList', name: '退票已锁核销异常待处理', component: refundList},
        {path: 'hxycdclRefundList', name: '退票核销异常待处理', component: refundList},
        {path: 'hxycddRefundList', name: '退票全部核销异常订单', component: refundList},
        {path: 'tpqxrefundList', name: '退票取消', component: refundList},
        {path: 'refundList', name: '运营退票单查询', component: refundList},
        {path: 'cgrefundList', name: '采购退票单查询', component: refundList},
        {path: 'gyrefundList', name: '供应退票单查询', component: refundList},
        {path: 'hxycdjsRefundList', name: '核销异常待结算', component: refundList},
        {path: 'hxycyjsrefundList', name: '核销异常已结算', component: refundList},
        {path: 'djsrefundList', name: '退票待结算', component: refundList},
        {path: 'yjsrefundList', name: '退票已结算', component: refundList},
        {path: 'refundRemindConfig', name: '退票提醒信息设置', component: refundRemindConfig},
        {path: 'refundDetail', name: '退票详情', component: refundDetail},
        {path: 'addHandMadeRefundOrder', name: '退票申请', component: addHandMadeRefundOrder},
        // 改签
        {path: 'changeList', name: '运营改签单查询', component: changeList},
        {path: 'cgchangeList', name: '采购改签单查询', component: changeList},
        {path: 'gychangeList', name: '供应改签单查询', component: changeList},
        {path: 'ysdclChangeList', name: '改签已锁待处理', component: changeList},
        {path: 'ysjsycdclChangeList', name: '改签已锁结算异常待处理', component: changeList},
        {path: 'ysjsycChangeList', name: '改签已锁结算异常', component: changeList},
        {path: 'ysgqzChangeList', name: '已锁改签中', component: changeList},
        {path: 'yswtgqChangeList', name: '已锁未退票改签单', component: changeList},
        {path: 'dclchangeList', name: '改签全部待处理', component: changeList},
        {path: 'jsycdclchangeList', name: '改签全部结算异常待处理', component: changeList},
        {path: 'gqzchangeList', name: '全部改签中', component: changeList},
        {path: 'wtgqChangeList', name: '全部未退票改签单', component: changeList},
        {path: 'gqqxchangeList', name: '改签取消', component: changeList},
        {path: 'djschangeList', name: '待结算', component: changeList},
        {path: 'yjschangeList', name: '已结算', component: changeList},
        {path: 'orderAppealList', name: '申诉订单', component: orderAppealList},
        {path: 'orderAssistList', name: '辅助下单', component: orderAssistList},
        {path: 'billList', name: '账单', component: billList},
        {path: 'merchantCashList', name: '商户现金明细', component: merchantCashList},
        {path: 'capitalTradeList', name: '资金交易明细', component: capitalTradeList},
        {path: 'logs', name: '系统日志', component: logs},
        {path: 'bookinglogs', name: '系统日志', component: bookinglogs},
        {path: 'product', name: '产品管理', component: product},
        {path: 'productConfig', name: '产品管理', component: productConfig},
        {path: 'productPushLogst', name: '投放日志', component: productPushLogst},
        {path: 'productLogst', name: '产品日志', component: productLogst},
        {path: 'productAircomConfig', name: '航司调价', component: productAircomConfig},
        {path: 'productAirlineConfig', name: '航线调价', component: productAirlineConfig},
        {path: 'ticketoutConfig', name: '出票设置', component: ticketoutConfig},
        {path: 'ticketOutAV', name: '出票自动AV/订座表', component: ticketOutAV},
        {path: 'xcdList', name: '行程单', component: xcdList},
        {path: 'orderScan', name: '刷票订单', component: orderScan},
        {path: 'productDzFilter', name: '出票过滤', component: productDzFilter},
        {path: 'refundTimeConfig', name: '退票提醒时间设置', component: refundTimeConfig},
        {path: 'refundProcessingTime', name: '退票处理时限', component: refundProcessingTime},
        {path: 'fzxljy', name: '飞猪国际行李额解压', component: fzxljy},
        {path: 'addHandMadeChangeOrder', name: '改签申请', component: addHandMadeChangeOrder},
        {path: 'changeDetail', name: '改签详情', component: changeDetail},
        // 异常
        {path: 'orderErrorList', name: '异常订单查询', component: orderErrorList},
        {path: 'ysdclErrorList', name: '异常已锁待处理', component: orderErrorList},
        {path: 'allErrorList', name: '异常全部待处理', component: orderErrorList},
        {path: 'ysychkErrorList', name: '已锁异常回款', component: orderErrorList},
        {path: 'allychkErrorList', name: '全部异常回款', component: orderErrorList},
        {path: 'ysjsycErrorList', name: '已锁结算异常', component: orderErrorList},
        {path: 'alljsErrorList', name: '全部结算异常', component: orderErrorList},
        {path: 'ycqxErrorList', name: '异常取消', component: orderErrorList},
        {path: 'yshxycErrorList', name: '已锁核销异常待处理', component: orderErrorList},
        {path: 'allhxycErrorList', name: '全部核销异常待处理', component: orderErrorList},
        {path: 'djsErrorList', name: '异常待结算', component: orderErrorList},
        {path: 'yjsErrorList', name: '异常已结算', component: orderErrorList},
        // 资源
        {path: 'airlineCycle', name: '航班周期管理', component: airlineCycle},
        {path: 'freightDomestic', name: '官网运价NEW', component: freightDomestic},
        {path: 'freightDomesticOld', name: '官网运价', component: freightDomesticOld},
        {path: 'scheduling', name: '任务调度', component: scheduling},
        {path: 'cacheManage', name: '缓存管理', component: cacheManage},
        {path: 'lowPriceSearch', name: '比价查询', component: lowPriceSearch},
        {path: 'OutPurchasePolicy', name: '外部运价查询', component: OutPurchasePolicy},
        // 财税
        {path: 'orderStatistics', name: '订单统计', component: orderStatistics},
        {path: 'orderReportPassengers', name: '出票单报表', component: orderReportPassengers},
        {path: 'refundOrderReport', name: '退票单报表', component: refundOrderReport},
        {path: 'changeOrderReport', name: '改签单报表', component: changeOrderReport},
        {path: 'errorOrderReport', name: '异常订单报表', component: errorOrderReport},
        {path: 'orderFlightSummaryReport', name: '出票实时汇总报表', component: orderFlightSummaryReport}
      ]
    },
    // {
    //   path: '/orderDetail',
    //   name: '订单详情管理',
    //   component: orderDetail,
    //   hidden: true
    // },
    // {
    //   path: '/refundDetail',
    //   name: '退票申请',
    //   component: refundDetail,
    //   hidden: true
    // },
    // {
    //   path: '/changeDetail',
    //   name: '改签申请',
    //   component: changeDetail,
    //   hidden: true
    // },
    {
      path: '/orderErrorDetail',
      name: '异常录入',
      component: orderErrorDetail,
      hidden: true
    },
    // {
    //   path: '/addHandMadeRefundOrder',
    //   name: '录入退票单',
    //   component: addHandMadeRefundOrder,
    //   hidden: true
    // },
    // {
    //   path: '/addHandMadeChangeOrder',
    //   name: '改签申请',
    //   component: addHandMadeChangeOrder,
    //   hidden: true
    // },
    {
      path: '/addHandMadeOrder',
      name: '录入出票单',
      component: addHandMadeOrder,
      hidden: true
    },
    {
      path: '/orderAppealDetail',
      name: '申诉订单详情',
      component: orderAppealDetail,
      hidden: true
    },
    {
      path: '/login',
      component: login,
      name: '',
      hidden: true
    },
    {
      path: '/externalmenu',
      component: externalmenu,
      name: 'externalmenu',
      children: []
    },
    {
      path: '/forgotPassword',
      component: forgotPassword,
      name: '修改密码',
      hidden: true
    },
    {
      path: '/table',
      component: table,
      name: '',
      hidden: true
    },
    {
      path: '/choice',
      component: choice,
      name: 'choice'
    },
    {
      path: '/demotree',
      component: demotree,
      name: 'demotree'
    },
    {path: '/h5', name: 'h5', component: h5},
    {path: '/loginH5', name: '登陆', component: loginH5},
    {path: '/listH5', name: '列', component: listH5}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js